/* Central place for the two URLs the landing links out to. Override at
 * build time via VITE_PLANNER_URL / VITE_INTRAOP_URL so the same code
 * works in local dev (localhost:5173, localhost:5174) and in production
 * (plan.cadtomie.com, intraop.cadtomie.com). */

export const PLANNER_URL: string =
  import.meta.env.VITE_PLANNER_URL ?? "https://plan.cadtomie.com";

export const INTRAOP_URL: string =
  import.meta.env.VITE_INTRAOP_URL ?? "https://intraop.cadtomie.com";

export const CONTACT_EMAIL = "cadtomie@gmail.com";
export const FORMSPREE_ENDPOINT = "https://formspree.io/f/xbdqrldy";
export const YOUTUBE_URL = "https://www.youtube.com/@cadtomie";

/* Marketing links for .intraop route through the dedicated product page
 * (/intraop.html) instead of straight to the app, so we can present the
 * App Store download there. INTRAOP_URL itself still resolves to the real
 * PWA and stays reachable FROM that page — Android/browser users must not
 * lose direct access. */
export const INTRAOP_PAGE_URL = "/intraop.html";
export const APP_STORE_URL =
  "https://apps.apple.com/de/app/cadtomie-intraop/id6770692246";
